import { useState } from "react";
import useApi from "../../hooks/useApi";

export default function VendorReview() {
  const { get } = useApi();
  const [searchTerm, setSearchTerm] = useState(""); // 🔍 Search state

  // 🔐 Decode token → vendor user id
  const getVendorIdFromToken = () => {
    const token = sessionStorage.getItem("token");
    if (!token) return null;

    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.sub; // ✅ users.id (vendor id)
    } catch {
      return null;
    }
  };

  const vendorId = getVendorIdFromToken();

  const { data, isLoading, isError, error } = get("/allreview");
  const reviews = data?.data || [];

  // 🎯 Filter reviews for this vendor
  const vendorReviews = vendorId
    ? reviews.filter((review) => Number(review.vendor_id) === Number(vendorId))
    : [];

  // 🟢 Apply search filter by customer name OR review comment
  const filteredReviews = vendorReviews.filter(
    (review) =>
      review.customer_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      review.comment.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const renderStars = (rating) => (
    <ul className="rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <li key={star}>
          <i className={`fas fa-star ${star <= rating ? "theme-color" : ""}`}></i>
        </li>
      ))}
    </ul>
  );

  return (
    <div className="card shadow-sm border-0">
      <div className="card-header bg-white border-0 d-flex align-items-center justify-content-between">
        <h5 className="mb-0 fw-semibold">My Reviews</h5>
        {/* Search input */}
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search by customer or review"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="table-responsive">
        <table className="table align-middle table-hover mb-0">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Customer</th>
              <th className="text-center">Rating</th>
              <th>Review</th>
            </tr>
          </thead>

          <tbody>
            {isLoading && (
              <tr>
                <td colSpan="4" className="text-center py-4">
                  Loading...
                </td>
              </tr>
            )}

            {!isLoading && filteredReviews.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center py-4 text-muted">
                  No reviews found
                </td>
              </tr>
            )}

            {!isLoading &&
              filteredReviews.map((review, index) => (
                <tr key={review.review_id}>
                  <td className="fw-semibold">{index + 1}</td>
                  <td>{review.customer_name}</td>
                  <td className="text-center">{renderStars(review.rating)}</td>
                  <td>
                    <span className="text-secondary">{review.comment}</span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
